<template>
  <v-card>
    <v-card-title>
      <h2>{{ formTitle }}</h2>
    </v-card-title>
    <v-card-text>
      <v-form class="my-3">
        <v-flex xs12>
          <content-field
            label="Title"
            :error="$v.typeForm.title"
            v-model="typeForm.title"/>
          <v-flex xs3>
            <e-color-picker
              v-if='typeForm.fontColor'
              label="Font Color"
              v-model="typeForm.fontColor"
              @colorChange="onColorChange"/>
          </v-flex>
          <v-flex xs5>
            <v-select
              autocomplete
              :items="arrayOfFontFamily"
              v-model="typeForm.fontFamily"
              label="Font Family">
              <template slot="selection" slot-scope="data">
                <span :style="selectedFontFamily">
                  {{ data.item }}
                </span>
              </template>
              <template slot="item" slot-scope="data">
                <span :style="currentFontFamily(data.item)">
                  {{ data.item }}
                </span>
              </template>
            </v-select>
          </v-flex>
          <v-layout row justify-space-between wrap>
            <v-flex xs5>
              <content-field
              label="Font size"
              :error="$v.typeForm.fontSize"
              v-model="typeForm.fontSize"/>
            </v-flex>
            <v-flex xs5>
              <v-select
                autocomplete
                :items="arrayForWeight"
                v-model="typeForm.fontWeight"
                label="Font weight"/>
            </v-flex>
             <v-flex xs5>
               <v-checkbox
                v-model="typeForm.isShowLinks"
                :label="`Show links`"
               ></v-checkbox>
            </v-flex>
            <!--<v-flex xs3>-->
              <!--<v-select-->
                <!--label="Image effect"-->
                <!--v-model="typeForm.imageEffect"-->
                <!--:items="imageEffects"/>-->
            <!--</v-flex>-->
          </v-layout>

        </v-flex>
      </v-form>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer/>
      <v-btn color="error"  dark large @click.stop="close">Cancel</v-btn>
      <v-btn color="success" dark  large @click.stop="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import EColorPicker from '@/components/shared/EColorPicker'
import { required, numeric } from 'vuelidate/lib/validators'
import fontSizeValidation from '@/utils/validators/isFontSizeValid'
import lodash from 'lodash'
import { pathOr } from 'ramda'

export default {
  name: 'FormSponsorsTypes',
  components: {
    ContentField,
    EColorPicker
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    isCreate: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      typeForm: {},
      // imageEffects: ['None', 'FocusIn', 'FocusOut'],
      arrayForWeight: [100, 200, 300, 400, 500, 600, 700, 800],
      arrayOfFontFamily: [
        'Montserrat',
        'Helvetica',
        'Arial',
        'Arial Black',
        'Trebuchet MS',
        'Bookman',
        'Georgia',
        'Garamond',
        'Impact',
        'Tahoma',
        'Palatino',
        'Courier',
        'Times New Roman',
        'Verdana',
        'Montserrat',
        'Roboto',
        'Roboto Slab',
        'Nanum Gothic',
        'Encode Sans Condensed',
        'Oswald',
        'Fira Sans',
        'Libre Franklin',
        'Tajawal'
      ],
    }
  },
  validations: {
    typeForm: {
      title: {required},
      fontFamily: {required},
      fontSize: {
        required,
        numeric,
        fontSizeValidation
      }
    }
  },
  watch: {
    form (val) {
      this.typeForm = lodash.cloneDeep(val)
    }
  },
  mounted () {
    this.typeForm = lodash.cloneDeep(this.form)
  },
  computed: {
    formTitle () {
      return this.isCreate ? 'New Type' : 'Edit Type'
    },
    selectedFontFamily () {
      const fontFamilyValue = `${pathOr('Roboto', ['fontFamily'], this.typeForm)},sans-serif`
      return { fontFamily: fontFamilyValue, color: '#000000' }
    }
  },
  methods: {
    onColorChange (color) {
      this.typeForm.fontColor.hex = color.hex
    },
    save (){
      this.$v.typeForm.$touch()
      if (!this.$v.typeForm.$invalid) {
        this.$emit('saveSponsorsType', this.typeForm)
      }
    },
    close () {
      this.$emit('close')
    },
    currentFontFamily (item) {
      return { fontFamily: `${item},sans-serif` || '' }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Settings/SponsorsTypes/FormSponsorsTypes.vue